import { DomeComponent, DomeManipulator, DomeRouter, React } from "@lexriver/dome";
import { EnumIconNames } from "../enums/EnumIconNames";
import { GlobalLeftSidebar } from "../GlobalLeftSidebar";
import { GlobalState } from "../GlobalState";
import imgWhatsapp from '../img/icons8-whatsapp.svg';
import imgLogo from '../img/uvelina-logo.svg';
import { UrlGenerator } from "../UrlGenerator";
import { BasketTop } from "./BasketTop";
import { FavoritesTopIcon } from "./FavoritesTopIcon";
import { Icon } from "./Icon";
import { ProfileTopIcon } from "./ProfileTopIcon";
import css from './Topbar.m.scss';
import { TopSearch } from "./TopSearch";


interface Attrs{

}

export class Topbar extends DomeComponent<Attrs>{
    //sidebarIsOpen:boolean = false
    refContainer!:HTMLDivElement
    refPhoneContainer!:HTMLDivElement
    refLogoContainer!:HTMLDivElement
    iconMenu!:Icon 
    render(){
        return <>
        <div class={css.topbar} ref={ref => this.refContainer = ref}>
            <div class={css.menuPlusLogoContainer}>
                <div onClick={async () => { await GlobalLeftSidebar.showAsync(); }} /* onTouchEnd={(e) => { e.stopPropagation(); console.log('!'); GlobalLeftSidebar.show(); }} */ class={css.menuButton}>
                    <Icon iconName={EnumIconNames.Menu} ref={ref => this.iconMenu = ref} />
                </div>
                <div style={{width: '10px'}} />
                <TopSearch />                
            </div>

            {/* <div class={css.phone} ref={ref => this.refPhoneContainer = ref}></div> */}
            <div class={css.logo} onClick={() => DomeRouter.navigate(UrlGenerator.home)} ref={ref => this.refLogoContainer = ref}>
                <img src={imgLogo}/>
            </div>


            <div class={css.rightContainer}>

                <ProfileTopIcon />
                {/* <span class={EnumIconNames.HeartEmpty} style={{ fontSize: "20px", margin: '0 3px' }}  ></span> */}
                <FavoritesTopIcon />
                <BasketTop />
            </div>
        </div>
        </>
    }

    async afterRender() {
        GlobalState.topBarSearchIsVisibleO.eventOnChange.subscribe((isVisible) => {
            if(!DomeManipulator.isInDom(this.refContainer)){
                return {unsubscribe:true}
            }
            if(screen.width<400){
                this.refLogoContainer.style.display = isVisible ? 'none' : 'block'
            } else {
                this.refLogoContainer.style.display = 'block'
            }
        })

        document.body.appendChild(
            <a href="https://api.whatsapp.com/send?phone=79137374038" target="_blank"><img src={imgWhatsapp} class={css.whatsappIcon} /></a>
            
        )

    }

    // async updateAsync(): Promise<void> {
        
    // }
    // async afterRender(){
    //     // this.refLogoContainer.innerHTML = await ServerSettings.getOnlyValueAsync('top-logo')
    //     // this.refSecondLogoContainer.innerHTML = await ServerSettings.getOnlyValueAsync('top-second-logo')
    //     // this.refSecondLogoContainer.onclick = (e) => {
    //     //     PopupAsync.showPopupAsync(() => <div ref={async (ref) => ref.innerHTML = await ServerSettings.getOnlyValueAsync('top-second-logo-popup')}></div>)
    //     // }
    //     this.refPhoneContainer.innerHTML = await ServerSettings.getOnlyValueAsync('top-phone')
    //     this.refPhoneContainer.innerHTML = Settings.replacePhoneNumberWithLink(this.refPhoneContainer.innerText)
    // }

}